const intlOnError = (error, isTranslationsAvailable) => {
  // Check if translations are available from the backend and received without errors
  if (isTranslationsAvailable) {
    // eslint-disable-next-line no-console
    console.warn(error);
  }
};

export default intlOnError;
